import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import classes from './SidePageFormTitle.module.css';
export const SidePageFormTitle = (props) => {
    return _jsx("h2", { className: clsx(classes.title), children: props.text || null });
};
